<!-- color settings (don't delete) -->
@if (isOwner) {
  <bmcore-color-settings></bmcore-color-settings>
}
@if (pageIsNotAvailable) {
  <div>
    <bmcore-page-not-found [pageIsNotAvailable]="true"> </bmcore-page-not-found>
  </div>
} @else {
  @if (!idIsDetected) {
    <div class="bm--loader-box">
      <bmcore-loader></bmcore-loader>
    </div>
  } @else {
    <div class="common-app theme-app__bg">
      <bmprod-header [currentRoute]="currentRoute"></bmprod-header>
      <!-- Header offset -->
      <div class="offset"></div>
      <div [ngClass]="{ 'app__cart-popup': showCartPopup }" (click)="closeCartPopup()">
        <router-outlet></router-outlet>
      </div>
      <div class="bm--footer__box theme-footer">
        @if (isDividingLine) {
          <bmcore-dividing-line></bmcore-dividing-line>
        }
        <bmprod-footer></bmprod-footer>
      </div>
    </div>
    <!-- Blocks independent of routing -->
    <bmprod-player></bmprod-player>
    <bmcore-player-mob [showShareBtn]="true"></bmcore-player-mob>
    <bmprod-select-license-popup></bmprod-select-license-popup>
    <bmprod-share-track-popup></bmprod-share-track-popup>
    <bmprod-cookie-policy-popup></bmprod-cookie-policy-popup>
    <bmcore-color-customizer [appType]="'PROD-PAGE'"></bmcore-color-customizer>
    <bmcore-notification></bmcore-notification>
  }
}
